import { DEFAULT_CURRENCY, DEFAULT_LOCALE } from "../constants";

const toDate = (value: Date | string): Date =>
  typeof value === "string" ? new Date(value) : value;

export const formatDate = (
  value: Date | string,
  locale = DEFAULT_LOCALE,
): string =>
  new Intl.DateTimeFormat(locale, {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(toDate(value));

export const formatDateTime = (
  value: Date | string,
  locale = DEFAULT_LOCALE,
): string =>
  new Intl.DateTimeFormat(locale, {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(toDate(value));

export const formatNumber = (value: number, locale = DEFAULT_LOCALE): string =>
  new Intl.NumberFormat(locale).format(value);

export const formatPrice = (
  value: number,
  currency = DEFAULT_CURRENCY,
  locale = DEFAULT_LOCALE,
): string =>
  new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  }).format(value);
